import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "pt-10 px-12",
  style: {"height":"720px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_calendar = _resolveComponent("v-calendar")!
  const _component_event_dialog_container = _resolveComponent("event-dialog-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_page_title, { value: "年間行事予定" }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 0,
              class: "mx-2",
              color: "primary",
              indeterminate: ""
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createDialog = true)),
          color: "primary",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-plus", -1)
              ]))]),
              _: 1
            }),
            _cache[5] || (_cache[5] = _createTextVNode(" 追加 ", -1))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_toolbar, {
        variant: "flat",
        color: "white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            fab: "",
            variant: "text",
            size: "large",
            color: "grey-darken-2",
            onClick: _ctx.prevMonth
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { small: "" }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode(" mdi-chevron-left ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_btn, {
            fab: "",
            variant: "text",
            size: "large",
            color: "grey-darken-2",
            onClick: _ctx.nextMonth
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { small: "" }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode(" mdi-chevron-right ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          (_ctx.calendarTitle)
            ? (_openBlock(), _createBlock(_component_v_toolbar_title, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.calendarTitle), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_calendar, {
        modelValue: _ctx.model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model) = $event)),
        events: _ctx.formattedEvents,
        "onClick:event": _ctx.clickEvent,
        "view-mode": "month",
        locale: "ja",
        color: "primary"
      }, null, 8, ["modelValue", "events", "onClick:event"])
    ]),
    _createVNode(_component_event_dialog_container, {
      dialogType: "create",
      isOpen: _ctx.createDialog,
      onIsOpen: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createDialog = $event))
    }, null, 8, ["isOpen"]),
    _createVNode(_component_event_dialog_container, {
      dialogType: "update",
      isOpen: _ctx.updateDialog,
      onIsOpen: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateDialog = $event))
    }, null, 8, ["isOpen"])
  ]))
}